module.exports = __webpack_public_path__ + "img/email-vcard-white.097d948e.svg";